import { createI18n } from 'vue-i18n' // Vue3 专用
import zh from './config/zh'
import en from './config/en'
import br from './config/br'


const i18n = createI18n({
    legacy: false, // 必须关闭旧模式
    locale: localStorage.getItem('locale') || 'en',
    messages: { zh, en, br}
})

export default i18n
